// extracted by mini-css-extract-plugin
module.exports = {"glossary":"_7WmmR7f","glossaryContent":"_1Jx8IrQ","glossaryTerm":"_1BnUj_j","glossaryDefinition":"_2TrD1pA","alphabeticalNavIndex":"_1z5w9bA","activeIndex":"_3OHxAKZ"};